import { useGetAllLives } from '@/app/hooks/useGetAllLives'
import { useTrainingQueries } from '@/app/hooks/useTrainingQueries'
import { TrainingCard } from './components/TrainingCard'
import { ViewLive } from './components/ViewLive'

export default function Tranings() {
  const { data } = useTrainingQueries(0, 100, '')

  const { data: lives } = useGetAllLives({
    skip: 0,
    limit: 1,
    search: '',
  })

  const live = lives?.lives[0]

  return (
    <div className="my-5 grid min-h-full w-full flex-1 grid-cols-3 flex-col gap-8">
      <div className=" col-span-2 grid w-full grid-cols-2 gap-5">
        {data?.trainings.map((training, index) => (
          <TrainingCard
            key={training._id}
            training={training}
            isEven={index % 2 === 0}
          />
        ))}
      </div>

      {live && <ViewLive live={live} />}
    </div>
  )
}
